import { ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines Tailwind CSS classes with proper precedence
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/**
 * Format date to readable string
 */
export function formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
        day: 'numeric',
    })
}

/**
 * Format date range (e.g., for experience or education)
 */
export function formatDateRange(startDate: string | Date, endDate: string | Date | null): string {
    const start = new Date(startDate).toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
    })

    const end = endDate
        ? new Date(endDate).toLocaleDateString('en-US', {
            month: 'short',
            year: 'numeric',
        })
        : 'Present'

    return `${start} - ${end}`
}

/**
 * Truncate text to specified length
 */
export function truncateText(text: string, maxLength: number): string {
    if (text.length <= maxLength) return text
    return text.slice(0, maxLength) + '...'
}

/**
 * Generate initials from name
 */
export function getInitials(name: string): string {
    return name
        .split(' ')
        .map(part => part[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
}

/**
 * Check if URL is external
 */
export function isExternalUrl(url: string): boolean {
    return url.startsWith('http') || url.startsWith('//')
}